module.exports = __webpack_public_path__ + "assets/b53767a47049cb1a3862e4558ff3e1b6.png";